import { useEffect, useLayoutEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { NumPad, useClickOutside } from '@pascal/pascal-core';

import { MobileBetSection } from './mobileBetSection';
import { NumPadWr } from '../../containers/mobile/numPadWr/numPad';

let mobileWrRef;

export const MobileBetSectionWrapper = observer(
  ({
    t,
    odd,
    isOpen,
    isDemo,
    limits,
    betAmount,
    reBetData,
    setBetAmount,
    activeButton,
    handleSubmit,
    activeFreeBet,
    setNumPadData,
    handleClickBet,
    handleInputBlur,
    totalBetsAmount,
    numPudInputValue,
    betPendingToggle,
    reBetPendingToggle,
    handleOpenNumPad,
    partnerWageringOdd,
    decidedCallBackCall,
    setIsValidatedAmount,
    updateNumPudInputValue,
    handleChangeInputValue,
  }) => {
    useLayoutEffect(() => {
      mobileWrRef = document.querySelector('.mobile-wr');
    }, []);

    const [ref, hasClickedOutside] = useClickOutside();

    useEffect(() => {
      if (hasClickedOutside) {
        setNumPadData({ isOpen: false, currentInputValue: null });
      }
    }, [hasClickedOutside]);

    return (
      <>
        <MobileBetSection
          t={t}
          odd={odd}
          isDemo={isDemo}
          limits={limits}
          reBetData={reBetData}
          betAmount={betAmount}
          activeButton={activeButton}
          setBetAmount={setBetAmount}
          activeFreeBet={activeFreeBet}
          handleClickBet={handleClickBet}
          totalBetsAmount={totalBetsAmount}
          handleInputBlur={handleInputBlur}
          handleOpenNumPad={handleOpenNumPad}
          betPendingToggle={betPendingToggle}
          reBetPendingToggle={reBetPendingToggle}
          partnerWageringOdd={partnerWageringOdd}
          decidedCallBackCall={decidedCallBackCall}
          setIsValidatedAmount={setIsValidatedAmount}
          handleChangeInputValue={handleChangeInputValue}
        />
        {!activeFreeBet.id && (
          <NumPadWr containerRef={mobileWrRef}>
            <div ref={ref} className='numpad-wr-for-outside-click'>
              <NumPad
                t={t}
                isOpen={isOpen}
                limits={limits}
                onSubmit={handleSubmit}
                amountValue={numPudInputValue}
                setAmountValue={updateNumPudInputValue}
              />
            </div>
          </NumPadWr>
        )}
      </>
    );
  }
);
